import * as ForwardViewletCommand from '../ForwardViewletCommand/ForwardViewletCommand.js'

export const handleClickAction = ForwardViewletCommand.forwardViewletCommand('handleClickAction')
